import React, { useEffect, useState } from 'react'
import { AnimatedCounterProps } from './AnimatedCounter.types'
import styles from './AnimatedCounter.module.scss'
import cl from 'classnames'
import { formatPrice } from 'utilities'

const AnimatedCounterComponent = (props: AnimatedCounterProps) => {
  const {
    className,
    style,
    num,
    customFormattedTime,
    duration = 1,
    isPrice,
    delay = 0
  } = props

  const [count, setCount] = useState(0)

  useEffect(() => {
    let start = 0
    const end = Number(num.toString())

    if (start === end) return

    const incrementTime = (duration / end) * 1000
    let timer = null
    const timeout = setTimeout(() => {
      timer = setInterval(() => {
        start += 1
        const nextCount = Math.min(Number(String(start) + num.toString()), end)
        setCount(nextCount)
        if (start >= end) clearInterval(timer)
      }, incrementTime)
    }, delay * 1000)

    return () => {
      clearInterval(timer)
      clearTimeout(timeout)
    }
  }, [num, duration, delay])

  return (
    <span
      className={cl(styles.container, className)}
      style={style}
    >
      {isPrice
        ? formatPrice(count)
        : customFormattedTime 
        ? customFormattedTime 
        : count}
    </span>
  )
}

const AnimatedCounter = AnimatedCounterComponent
export { AnimatedCounter }
